import React, { Component } from 'react';
import { Button } from 'semantic-ui-react';
import './styles.scss';
import { withTranslation } from "react-i18next";
import { compose } from 'redux';

class BackToTop extends Component {

    // Back To Top
    backToTop = (e) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    render() {
        const { t } = this.props;

        // Show Back To Top button when scrolling down
        document.addEventListener('scroll', function () {
            if (document.querySelector('.back-to-top') != null) {
                if (window.pageYOffset >= document.body.offsetHeight / 4) {
                    document.querySelector('.back-to-top').classList.add('fadeIn');
                } else {
                    document.querySelector('.back-to-top').classList.remove('fadeIn');
                }
            }
        });

        return (
            <div className="back-to-top" onClick={(e) => this.backToTop()}>
                <Button size="large" icon><span>&nbsp;</span></Button>
                <span>{t('button.backToTop')}</span>
            </div>
        );
    }
}

export default compose(
    withTranslation()
)(BackToTop);

